import { render, staticRenderFns } from "./DriversTestimonialsCarousel.vue?vue&type=template&id=1393793d&"
import script from "./DriversTestimonialsCarousel.vue?vue&type=script&lang=js&"
export * from "./DriversTestimonialsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./DriversTestimonialsCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports